import { render, staticRenderFns } from "./HelpDeskRootView.vue?vue&type=template&id=1459c0b6"
import script from "./HelpDeskRootView.vue?vue&type=script&lang=js"
export * from "./HelpDeskRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports